export default __webpack_public_path__ + "src/assets/uniseth-mobile.9138496827351b097600f3de6547f9c7.svg";